import "./vyneInputAddonWrapper.scss";
import { Space } from "antd";

import type { ReactNode } from "react";
import type { SpaceCompactProps } from "antd/es/space/Compact";

type AddonRender = (className?: string) => ReactNode;
type AddonContent = ReactNode | AddonRender;

interface VyneInputAddonWrapperProps {
    readonly addonBefore?: AddonContent;
    readonly addonAfter?: AddonContent;
    readonly wrapperProps?: Omit<SpaceCompactProps, "children">;
    readonly children: ReactNode;
}

export const VyneInputAddonWrapper = ({
    addonBefore,
    addonAfter,
    wrapperProps,
    children,
}: VyneInputAddonWrapperProps) => {
    if (!addonBefore && !addonAfter) {
        return <>{children}</>;
    }

    const renderAddon = (addon: AddonContent) => {
        if (typeof addon === "function") {
            return addon();
        }

        return <>{addon}</>;
    };

    const wrapperClassName = ["vyne-input-addon-wrapper", wrapperProps?.className].filter(Boolean).join(" ");

    return (
        <Space.Compact
            {...wrapperProps}
            block={wrapperProps?.block ?? true}
            size={wrapperProps?.size ?? "middle"}
            className={wrapperClassName}
        >
            {!!addonBefore && (
                <span className="vyne-input-addon vyne-input-addon-before">{renderAddon(addonBefore)}</span>
            )}
            {children}
            {!!addonAfter && <span className="vyne-input-addon vyne-input-addon-after">{renderAddon(addonAfter)}</span>}
        </Space.Compact>
    );
};
